import CloudinaryImage from '../common/CloudinaryImage';

import '../common/common.css';

export default function ContactTrustedClient({ clientlogo }) {
  return (
    <div className="bg-[#000815] lg:py-[70px] py-[30px] lg:px-[50px] px-[30px]">
      {clientlogo?.title && (
        <p className="mb-[20px] text-[#fff] xl:text-[34px] lg::text-[28px] md:text-[24px] text-[18px] font-[800]">
          {clientlogo?.title}
        </p>
      )}
      <ul className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
        {clientlogo?.Companies?.map((data, key) => (
          <li
            key={key}
            className="flex items-center justify-center bg-[#38383880] rounded-[8px] h-[100px]"
          >
            <CloudinaryImage
              backendImgUrl={data?.image?.data?.attributes?.url}
              alt={data?.image?.data?.attributes?.alternativeText}
              className="max-w-[100px]"
              type="icon"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
